import axios from 'axios'
import Views from './Views'

// Add a request interceptor
axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    config.headers!['Authorization'] = 'Bearer ' + localStorage.jwt_token
    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

// Add a response interceptor
axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response
  },
  function (error) {
    // Do something with response error
    // can toast here
    return Promise.reject(error)
  }
)

const App = () => <Views />

export default App
